import { Box, styled } from '@mui/material';

export const DateNavigationContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4)
}));
